import { render, staticRenderFns } from "./scorecard-order-clubspecific-change.vue?vue&type=template&id=327be8aa&scoped=true"
import script from "./scorecard-order-clubspecific-change.vue?vue&type=script&lang=js"
export * from "./scorecard-order-clubspecific-change.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-clubspecific-change.vue?vue&type=style&index=0&id=327be8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327be8aa",
  null
  
)

export default component.exports